import React from 'react';
import { useTheme } from '../../../../../../../theme';
import { InfoDetails } from '../../../../../../../Icons';
const AirplaneName = ({ text, onClick }) => {
    const { AirplaneName: css } = useTheme('Entities').SeatMap;
    return (React.createElement("div", { className: css.wrapper, onClick: onClick },
        React.createElement("div", { className: css.text }, text),
        React.createElement("div", { className: css.icon }, InfoDetails)));
};
export default AirplaneName;
